<div class="grid-container col-1 cookie-container pl-0_5 pr-0_5 pt-0_5">
  <div class="cookie-description-text">
    This website stores cookies on your computer. These cookies are used to
    collect information about how you interact with our website and allow us to
    remember you. We use this information in order to improve and customize your
    browsing experience and for analytics and metrics about our visitors both on
    this website and other media. To find out more about the cookies we use, see
    our
    <a href="https://sleip.com/privacy-policy" target="_blank"
      >Privacy Policy.</a
    >
  </div>
  <div class="cookie-description-text">
    If you decline, your information won’t be tracked when you visit this
    website. A single cookie will be used in your browser to remember your
    preference not to be tracked.
  </div>
</div>

<ng-template #cookieDialogActions>
  <div
    class="grid-container cookie-actions col-gap-0 row-gap-0 pl-1_5 pr-1_5 pb-0_5"
  >
    <button
      class="mr-1_5"
      (click)="acceptAllCookies()"
      type="button"
      mat-flat-button
      color="primary"
    >
      Accept
    </button>
    <button
      class="button-text-primary-green grid-item-self-justify-left"
      (click)="declineAllCookies()"
      type="button"
      mat-stroked-button
    >
      Decline
    </button>
  </div>
</ng-template>
